import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const helpCenterSettingsWidgetConfigurationCustomizeRoute: InvariantJiraRoute = {
	name: 'helpcenter-settings-widget-configuration-customize',
	path: '/jira/helpcenter/projects/:projectKey/settings/:helpCenterId/embed/:widgetId/customize',
	exact: true,
};
